import { render, staticRenderFns } from "./assAuto.vue?vue&type=template&id=2f6a6560&scoped=true"
import script from "./assAuto.vue?vue&type=script&lang=js"
export * from "./assAuto.vue?vue&type=script&lang=js"
import style0 from "./assAuto.vue?vue&type=style&index=0&id=2f6a6560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6a6560",
  null
  
)

export default component.exports